/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const listPayerOrganizationsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({})
})
export const listPayerOrganizationsResponse = zod.array(listPayerOrganizationsResponseItem)

